import React, {Fragment, memo, useCallback, useEffect, useMemo, useRef, useState} from "react"
import {
    ALARM_VALUE_HOME, ALARM_VALUE_OUTSIDE,
    CONTROL_TYPE_ID_ALARM, CONTROL_TYPE_ID_ANALOG,
    CONTROL_TYPE_ID_DIMMER, CONTROL_TYPE_ID_ELEVATOR,
    CONTROL_TYPE_ID_DIMMER_COLOR,
    CONTROL_TYPE_ID_THERMOSTAT,
    ControlModel,
    ControlTypeModel,
    MEDIA_TYPE_ID_AIR_CONDITIONER,
    MediaModel,
    CONTROL_TYPE_ID_FANCOIL,
    SOUND_LEVEL_TYPE_ID,
    SOUND_PLAYED_TYPE_ID,
    CONTROL_TYPE_ID_GLASS_DEVICE_BUTTON,
    CONTROL_TYPE_ID_GLASS_DEVICE_SCREEN,
    CONTROL_TYPE_ID_VRF,
    CONTROL_TYPE_ADV_THERMOSTAT,
    HideControlParameters
} from "../../types/control"
import {useForceUpdate} from "../../hooks/force-update"
import {toggleScenarioScreenAction} from "../../store/ui/actions"

import "./index.scss"

import iconMinus from "../../assets/images/icons/controls/minus.png"
import iconPlus from "../../assets/images/icons/controls/plus.png"
import iconUpButton from "../../assets/images/icons/controls/up-button.png"
import iconEqualButton from "../../assets/images/icons/controls/equal-button.png"
import iconDownButton from "../../assets/images/icons/controls/down-button.png"
import iconCancel from "../../assets/images/icons/scenario/cancel.png"
import iconScenario from "../../assets/images/icons/scenario/photo.png"
import iconSave from "../../assets/images/icons/scenario/save.png"
import iconUpArrow from "../../assets/images/icons/scenario/up-arrow.png"
import iconDownArrow from "../../assets/images/icons/scenario/down-arrow.png"
import iconClear from "../../assets/images/icons/scenario/clear.png"

import iconFanAuto from "../../assets/images/icons/fancoil-fan-a-sc.png"
import iconFanLow from "../../assets/images/icons/fancoil-fan-l-sc.png"
import iconFanMedium from "../../assets/images/icons/fancoil-fan-m-sc.png"
import iconFanHigh from "../../assets/images/icons/fancoil-fan-h-sc.png"
import iconOn from "../../assets/images/icons/on-icon.png"
import iconOff from "../../assets/images/icons/off-icon.png"
import iconCoolingActive from "../../assets/images/icons/controls/mod-cooling.png"
import iconHeatingActive from "../../assets/images/icons/controls/mod-heat.png"
import {useKeyboard} from "../../hooks/keyboard"
import {FancoilScenario, ScenarioModel, VRFScenario} from "../../store/control/state"
import {useRPC} from "../../hooks/rpc"
import {useDispatch, useSelector} from "react-redux"
import {usePrevious} from "../../hooks/previous"
import {onClickHandler} from "../../utils/onclick"
import {useSetSelector} from "../../hooks/set-selector"
import {useMessage} from "../../hooks/message"
import {mediaIcons} from "../MediaListScreen"
import {useLocalization} from "../../hooks/localization"
import {rgbToHex} from "../../components/ColorPicker/utils/convert"

import icon1 from "../../assets/images/icons/scenario/icons/scenario1.png"
import icon2 from "../../assets/images/icons/scenario/icons/scenario2.png"
import icon3 from "../../assets/images/icons/scenario/icons/scenario3.png"
import icon4 from "../../assets/images/icons/scenario/icons/scenario4.png"
import icon5 from "../../assets/images/icons/scenario/icons/scenario5.png"

import iconVRFAutoFan from '../../assets/images/icons/controls/vrf/auto-fan.png'
import iconVRFOffFan from '../../assets/images/icons/controls/vrf/power-off.png'
import iconVRFOneFan from "../../assets/images/icons/controls/vrf/slow-poweron.png"
import iconVRFTwoFan from "../../assets/images/icons/controls/vrf/low.png"
import iconVRFThreeFan from "../../assets/images/icons/controls/vrf/medium.png"
import iconVRFFourFan from "../../assets/images/icons/controls/vrf/high.png"

import iconVRFHeatMode from "../../assets/images/icons/controls/vrf/heat.png"
import iconVRFCoolMode from "../../assets/images/icons/controls/vrf/cool.png"
import iconVRFNemMode from "../../assets/images/icons/controls/vrf/nem.png"
import iconVRFAutoMode from "../../assets/images/icons/controls/vrf/auto.png"
import iconVRFFanMode from "../../assets/images/icons/controls/vrf/fan.png"


type DeviceInfo = {
    control: ControlModel;
    controlType: ControlTypeModel<unknown>;
    media: MediaModel;
    value: number;
    color?: any;
    fan_coil?: FancoilScenario;
    vrf?: VRFScenario;
};

type OperationInfo = {
    info: DeviceInfo;
    delay: number;
}

// const options = ['Hepsi', 'Oda', 'Kat', 'Tip', 'A-Z'];
const options = ["ALL", "AREA", "TYPE", "A-Z"]
const showTypes = ["is_notification", "show_on_footer"]
const checkSelected = (info: DeviceInfo, value: number) => info.value === value ? "selected" : ""

const colorList = [
    {r: 255, g: 0, b: 0},  //red
    {r: 255, g: 126, b: 0}, //orange
    {r: 255, g: 255, b: 0}, //yellow
    {r: 0, g: 255, b: 0},  //green
    {r: 0, g: 255, b: 162}, //teal
    {r: 0, g: 255, b: 255}, //lightblue
    {r: 0, g: 0, b: 255},   //blue
    {r: 123, g: 0, b: 255}, //deep purple
    {r: 200, g: 0, b: 255}, //purple
    {r: 255, g: 0, b: 217}, //pink
    {r: 255, g: 255, b: 255}, //white
]

const getNumber = (divider: number, delay: number) => {
    const value = Math.floor((delay / divider) % 60)
    if (value === 0) {
        return ""
    }

    let number = value.toFixed(0)
    if (number.length < 1) {
        number = "00"
    } else if (number.length < 2) {
        number = "0" + number
    }

    return number
}

const getDelay = (delay: number, t: (text: string) => string = null) => {

    const sec = getNumber(1, delay)
    const min = getNumber(60, delay)

    let output = ""

    if (min !== "") {
        output += `${min} ${t ? t("minute") : "dk"} `
    }

    if (sec === "") {
        output += `00 ${t ? t("second") : "sn"}`
    } else {
        output += `${sec} ${t ? t("second") : "sn"}`
    }

    return output
}
const getImage = (info: DeviceInfo): string => {
    // if (info.controlType.id === '6') {
    //     return info.controlType.image_set[`default_` + (info.control.settings as MediaDeviceSettings).media_control_icon.replace('-', '_')] ||
    //         info.controlType.image_set.default;
    // } // todo media scenario
    return info.controlType.image_set.default
}
type DeviceProps = {
    info: DeviceInfo;
    setSelected: (info: DeviceInfo, value: number) => void;
    increase: (info: DeviceInfo, min: number, max: number) => void;
    changeColor?: (info: DeviceInfo, isUp: boolean) => void;
    setMode?: (info: DeviceInfo, status: boolean) => void;
    setVRFMode?: (info: DeviceInfo, status: string) => void;
    setFanMode?: (info: DeviceInfo, value: string) => void;
    setVRFFanMode?: (info: DeviceInfo, value: string) => void;
    setPowerStatus?: (info: DeviceInfo, status: boolean) => void;
    setVRFPowerStatus?: (info: DeviceInfo, status: boolean) => void;
};

const SimpleDevice = memo(function SimpleDevice({
                                                    info,
                                                    setSelected,
                                                    isPulse
                                                }: Partial<DeviceProps> & { isPulse?: boolean }) {
    const {t} = useLocalization()
    const setZero = useCallback(() => {
        setSelected(info, 0)
    }, [info, setSelected])
    const setOne = useCallback(() => {
        setSelected(info, 1)
    }, [info, setSelected])

    return (
        <div className="device-body simple">
            {renderIf(!isPulse)(() => (
                <div className={"device-button " + checkSelected(info, 1)} {...onClickHandler(setOne)}>
                    <span>{info.controlType.id === "11" ? t("CALL") : "I"}</span>
                </div>
            ))}
            {renderIf(info.controlType.id !== "11" || isPulse)(() => (
                <div className={"device-button " + checkSelected(info, 0)} {...onClickHandler(setZero)}>
                    <span>0</span>
                </div>
            ))}
        </div>
    )
})

const ThreePhaseDevice = memo(function ThreePhaseDevice({info, setSelected}: Partial<DeviceProps>) {
    return (
        <div className="device-body">
            <div className={"device-button " + checkSelected(info, 1)}
                 {...onClickHandler(() => setSelected(info, 1))}>
                <img src={iconUpButton} alt=""/>
            </div>
            {
                renderIf(info.controlType.render_type === "three_phase")(() => (
                    <div className={"device-button " + checkSelected(info, 0)}
                         {...onClickHandler(() => setSelected(info, 0))}>
                        <img src={iconEqualButton} alt=""/>
                    </div>
                ))
            }
            <div className={"device-button " + checkSelected(info, 2)}
                 {...onClickHandler(() => setSelected(info, 2))}>
                <img src={iconDownButton} alt=""/>
            </div>
        </div>
    )
})

const Device = memo(function Device({info, setSelected, increase, changeColor, setPowerStatus, setFanMode, setVRFFanMode, setVRFMode, setVRFPowerStatus, setMode}: DeviceProps) {
    const {t} = useLocalization()
    const powerIcon: string = useMemo(() => {
        if (info?.fan_coil?.power_status) {
            return iconOn
        } else {
            return iconOff
        }
    }, [info?.fan_coil?.power_status])

    const vrfPowerIcon: string = useMemo(() => {
        if (info?.vrf?.power_status === 'on') {
            return iconOn
        } else {
            return iconOff
        }
    }, [info?.vrf?.power_status])

     const fanIcon: string = useMemo(() => {
         if (info?.fan_coil?.fan_speed === "low") {
            return iconFanLow
         } else if (info?.fan_coil?.fan_speed === "medium") {
            return iconFanMedium
         } else if (info?.fan_coil?.fan_speed === "high") {
            return iconFanHigh
         } else if (info?.fan_coil?.fan_speed === "auto") {
            return iconFanAuto
         }else{
            return iconFanAuto
         }
     }, [info?.fan_coil?.fan_speed])
     const modeIcon: string = useMemo(() => {
         if (info?.fan_coil?.mode) {
            return iconHeatingActive
         } else {
            return iconCoolingActive
         }
     }, [info?.fan_coil?.mode])

     const VRFFanIcon: string = useMemo(() => {
         //'slow' | 'low' | 'med' | 'high' | 'auto' | 'pwr'
         if (info?.vrf?.fan_speed === "slow") {
             return iconVRFOffFan
         } else if (info?.vrf?.fan_speed === "low") {
             return iconVRFOneFan
         } else if (info?.vrf?.fan_speed === "med") {
             return iconVRFTwoFan
         } else if (info?.vrf?.fan_speed === "high") {
             return iconVRFThreeFan
         } else if (info?.vrf?.fan_speed === "auto") {
             return iconVRFAutoFan
         } else if (info?.vrf?.fan_speed === "pwr") {
             return iconVRFFourFan
         } else {
             return iconVRFAutoFan
         }
     }, [info?.vrf?.fan_speed])

     const VRFModeIcon: string = useMemo(() => {
         //"cool" | "fan"| "ai" | "nem" | "heat"
         if (info?.vrf?.mode === "cool") {
             return iconVRFCoolMode
         } else if (info?.vrf?.mode === "fan") {
             return iconVRFFanMode
         } else if (info?.vrf?.mode === "ai") {
             return iconVRFAutoMode
         } else if (info?.vrf?.mode === "nem") {
             return iconVRFNemMode
         } else if (info?.vrf?.mode === "heat") {
             return iconVRFHeatMode
         } else {
             return iconVRFCoolMode
         }
     }, [info?.vrf?.mode])

    if (info.media != null) {
        if (info.media.type_id === MEDIA_TYPE_ID_AIR_CONDITIONER) {
            return (
                <div className="device-body simple">
                    <div className={"device-button " + checkSelected(info, 1)}
                         {...onClickHandler(() => setSelected(info, 1))}>
                        <span>I</span>
                    </div>
                    <div className={"device-button " + checkSelected(info, 0)}
                         {...onClickHandler(() => setSelected(info, 0))}>
                        <span>0</span>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="device-body simple">
                    <div className="device-button selected">
                        <span>I/0</span>
                    </div>
                </div>
            )
        }
    }

    if (info.controlType.render_type === "simple" || info.controlType.render_type === "pulse") {
        return (
            <SimpleDevice info={info} setSelected={setSelected}/>
        )
    }

    if (info.controlType.render_type === "three_phase" || info.controlType.render_type === "two_phase") {
        return (
            <ThreePhaseDevice info={info} setSelected={setSelected}/>
        )
    }

    switch (info.controlType.id) {
        case CONTROL_TYPE_ID_DIMMER:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{info.value}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_ANALOG:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{info.value}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case SOUND_LEVEL_TYPE_ID:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{info.value}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case SOUND_PLAYED_TYPE_ID:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{info.value}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_DIMMER_COLOR:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit" style={{display: "flex", justifyContent: "center", width: 54}}>
                        {info.value || 0}
                    </div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                    <div className="device-button" {...onClickHandler(() => changeColor(info, true))}>
                        <img src={iconUpButton} alt="" />
                    </div>
                    <div className="device-button" style={{backgroundColor: rgbToHex(info.color || colorList[0])}} />
                    <div className="device-button" {...onClickHandler(() => changeColor(info, false))}>
                        <img src={iconDownButton} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_GLASS_DEVICE_BUTTON:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -25, 0))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit" style={{display: "flex", justifyContent: "center", width: 54}}>
                        {info.value || 0}
                    </div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 25, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_GLASS_DEVICE_SCREEN:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -10, 10))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit" style={{display: "flex", justifyContent: "center", width: 54}}>
                        {info.value || 10}
                    </div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 10, 100))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_ALARM:
            return (
                <div className="device-body simple">
                    <div
                        className={"device-button " + checkSelected(info, ALARM_VALUE_HOME)}
                        {...onClickHandler(() => setSelected(info, ALARM_VALUE_HOME))}
                    >
                        <span>
                            {t("HOME")}
                        </span>
                    </div>
                    <div
                        className={"device-button " + checkSelected(info, ALARM_VALUE_OUTSIDE)}
                        {...onClickHandler(() => setSelected(info, ALARM_VALUE_OUTSIDE))}
                    >
                        <span>
                            {t("OUT")}
                        </span>
                    </div>
                </div>
            )
        // case '6':
        //     return (
        //         <SimpleDevice
        //             info={info}
        //             setSelected={setSelected}
        //             isPulse={(info.control.settings as MediaDeviceSettings).media_control_type_id !== '1'}
        //         />
        //     ); // todo media scenario
        case CONTROL_TYPE_ID_THERMOSTAT:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -5, 155))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{(info.value / 10).toFixed(1)}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 5, 320))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )
        case CONTROL_TYPE_ADV_THERMOSTAT:
            return (
                <div className="device-body">
                    <div className="device-button" {...onClickHandler(() => increase(info, -5, 155))}>
                        <img src={iconMinus} alt="" />
                    </div>
                    <div className="device-digit">{(info.value / 10).toFixed(1)}</div>
                    <div className="device-button" {...onClickHandler(() => increase(info, 5, 320))}>
                        <img src={iconPlus} alt="" />
                    </div>
                </div>
            )

        case CONTROL_TYPE_ID_FANCOIL:
            return (
                <div className="device-body">
                    <div className="device-body-actions" style={{gap: "0 0.2rem"}}>
                        <div className="device-button" {...onClickHandler(() => increase(info, -5, 155))}>
                            <img src={iconMinus} alt="" />
                        </div>
                        <div className="device-digit">{(info.value / 10).toFixed(1)}</div>
                        <div className="device-button" {...onClickHandler(() => increase(info, 5, 320))}>
                            <img src={iconPlus} alt="" />
                        </div>
                    </div>
                    <div className="device-body-actions" style={{marginLeft: "7px", gap: "0 0.3rem"}}>
                        <div className="device-button" {...onClickHandler(() => setMode(info, true))}>
                            <img src={modeIcon} alt="" />
                        </div>
                        <div className="device-button" {...onClickHandler(() => setFanMode(info, "auto"))}>
                            <img src={fanIcon} alt="" />
                        </div>
                        <div className="device-button" {...onClickHandler(() => setPowerStatus(info, false))}>
                            <img src={powerIcon} alt="" />
                        </div>
                    </div>
                </div>
            )

        case CONTROL_TYPE_ID_VRF:
            return (
                <div className="device-body" style={{width: "100%"}}>
                    <div className="device-body-actions" style={{width: "130px", justifyContent: "space-between"}}>
                        <div className="device-button" {...onClickHandler(() => increase(info, -10, 150))}>
                            <img src={iconMinus} alt="" />
                        </div>
                        <div className="device-digit">{(info.value / 10).toFixed(0)}</div>
                        <div className="device-button" {...onClickHandler(() => increase(info, 10, 330))}>
                            <img src={iconPlus} alt="" />
                        </div>
                    </div>
                    <div
                        className="device-body-actions"
                        style={{width: "150px", marginLeft: "5px", justifyContent: "space-between"}}
                    >
                        <div className="device-button" {...onClickHandler(() => setVRFFanMode(info, "slow"))}>
                            <img src={VRFFanIcon} alt="" />
                        </div>
                        <div className="device-button" {...onClickHandler(() => setVRFMode(info, "cool"))}>
                            <img src={VRFModeIcon} alt="" />
                        </div>
                        <div className="device-button" {...onClickHandler(() => setVRFPowerStatus(info, false))}>
                            <img src={vrfPowerIcon} alt="" />
                        </div>
                    </div>
                </div>
            )
    }

    return (
        <div className="device-body">

        </div>
    )
})

const SimpleScenario = memo(function SimpleScenario({
                                                        scenario,
                                                        isPulse
                                                    }: { scenario: OperationInfo; isPulse?: boolean }) {
    const {t} = useLocalization()
    return (
        <div className="device-body">
            {renderIf(!isPulse)(() => (
                <div className={"device-button " + checkSelected(scenario.info, 1)}>
                    <span>{scenario.info.controlType.id === "11" ? t("CALL") : "I"}</span>
                </div>
            ))}
            {renderIf(scenario.info.controlType.id !== "11" || isPulse)(() => (
                <div className={"device-button " + checkSelected(scenario.info, 0)}>
                    <span>0</span>
                </div>
            ))}
        </div>
    )
})

const ThreePhaseScenario = memo(function SimpleScenario({scenario}: { scenario: OperationInfo }) {
    return (
        <div className="device-body">
            <div className={"device-button " + checkSelected(scenario.info, 1)}>
                <img src={iconUpButton} alt=""/>
            </div>
            {
                renderIf(scenario.info.controlType.render_type === "three_phase")(() => (
                    <div className={"device-button " + checkSelected(scenario.info, 0)}>
                        <img src={iconEqualButton} alt=""/>
                    </div>
                ))
            }
            <div className={"device-button " + checkSelected(scenario.info, 2)}>
                <img src={iconDownButton} alt=""/>
            </div>
        </div>
    )
})

const Scenario = memo(function Scenario({scenario}: { scenario: OperationInfo }) {
    const {t} = useLocalization()

    console.log(scenario.info)
    const iconFan: string = useMemo(() => {
        if (scenario?.info?.fan_coil?.fan_speed === "low") {
            return iconFanLow
        } else if (scenario?.info?.fan_coil?.fan_speed === "medium") {
            return iconFanMedium
        } else if (scenario?.info?.fan_coil?.fan_speed === "high") {
            return iconFanHigh
        } else if (scenario?.info?.fan_coil?.fan_speed === "auto") {
            return iconFanAuto
        }else{
            return iconFanAuto
        }
    }, [scenario?.info?.fan_coil?.fan_speed])

    const iconPower: string = useMemo(() => {
        if (scenario?.info?.fan_coil?.power_status) {
            return iconOn
        } else {
            return iconOff
        }
    }, [scenario?.info?.fan_coil?.power_status])


    const vrfPowerIcon: string = useMemo(() => {
        if (scenario?.info?.vrf?.power_status === 'on') {
            return iconOn
        } else {
            return iconOff
        }
    }, [scenario?.info?.vrf?.power_status])

    const iconMode: string = useMemo(() => {
        if (scenario?.info?.fan_coil?.mode) {
            return iconHeatingActive
        } else {
            return iconCoolingActive
        }
    }, [scenario?.info?.fan_coil?.mode])


     const VRFFanIcon: string = useMemo(() => {
         //'slow' | 'low' | 'med' | 'high' | 'auto' | 'pwr'
         if (scenario?.info?.vrf?.fan_speed === "slow") {
             return iconVRFOffFan
         } else if (scenario?.info?.vrf?.fan_speed === "low") {
             return iconVRFOneFan
         } else if (scenario?.info?.vrf?.fan_speed === "med") {
             return iconVRFTwoFan
         } else if (scenario?.info?.vrf?.fan_speed === "high") {
             return iconVRFThreeFan
         } else if (scenario?.info?.vrf?.fan_speed === "auto") {
             return iconVRFAutoFan
         } else if (scenario?.info?.vrf?.fan_speed === "pwr") {
             return iconVRFFourFan
         } else {
             return iconVRFAutoFan
         }
     }, [scenario?.info?.vrf?.fan_speed])

     const VRFModeIcon: string = useMemo(() => {
         //"cool" | "fan"| "ai" | "nem" | "heat"
         if (scenario?.info?.vrf?.mode === "cool") {
             return iconVRFCoolMode
         } else if (scenario?.info?.vrf?.mode === "fan") {
             return iconVRFFanMode
         } else if (scenario?.info?.vrf?.mode === "ai") {
             return iconVRFAutoMode
         } else if (scenario?.info?.vrf?.mode === "nem") {
             return iconVRFNemMode
         } else if (scenario?.info?.vrf?.mode === "heat") {
             return iconVRFHeatMode
         } else {
             return iconVRFCoolMode
         }
     }, [scenario?.info?.vrf?.mode])


    if (scenario.info.media != null) {
        if (scenario.info.media.type_id === MEDIA_TYPE_ID_AIR_CONDITIONER) {
            return (
                <div className="device-body">
                    <div className={"device-button " + checkSelected(scenario.info, 1)}>
                        <span>I</span>
                    </div>
                    <div className={"device-button " + checkSelected(scenario.info, 0)}>
                        <span>0</span>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="device-body">
                    <div className="device-button selected">
                        <span>I/0</span>
                    </div>
                </div>
            )
        }
    }

    if (scenario.info.controlType.render_type === "simple" || scenario.info.controlType.render_type === "pulse") {
        return (
            <SimpleScenario scenario={scenario}/>
        )
    }

    if (scenario.info.controlType.render_type === "three_phase" || scenario.info.controlType.render_type === "two_phase") {
        return (
            <ThreePhaseScenario scenario={scenario}/>
        )
    }

    switch (scenario.info.controlType.id) {
        case CONTROL_TYPE_ID_DIMMER:
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                </div>
            )
        case CONTROL_TYPE_ID_GLASS_DEVICE_BUTTON:
            return (
                <div className="device-body">
                    <div className="device-digit">
                        {scenario?.info?.value === 0
                            ? 0
                            : scenario?.info?.value === 10
                            ? 25
                            : scenario?.info?.value === 20
                            ? 50
                            : scenario?.info?.value === 30
                            ? 75
                            : scenario?.info?.value === 40
                            ? 100
                            : scenario?.info?.value}
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_GLASS_DEVICE_SCREEN:
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                </div>
            )
        case CONTROL_TYPE_ID_DIMMER_COLOR:
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                    <div
                        className="device-color-button"
                        style={{
                            backgroundColor: rgbToHex(scenario.info.color || colorList[0])
                        }}
                    />
                </div>
            )
        case CONTROL_TYPE_ID_ANALOG:
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                </div>
            )
        case "300":
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                </div>
            )
        case "400":
            return (
                <div className="device-body">
                    <div className="device-digit">{scenario.info.value}</div>
                </div>
            )
        case CONTROL_TYPE_ID_ALARM:
            return (
                <div className="device-body">
                    <div className={"device-button " + checkSelected(scenario.info, ALARM_VALUE_HOME)}>
                        <span>{t("HOME")}</span>
                    </div>
                    <div className={"device-button " + checkSelected(scenario.info, ALARM_VALUE_OUTSIDE)}>
                        <span>{t("OUT")}</span>
                    </div>
                </div>
            )
        // case '6':
        //     return (
        //         <SimpleScenario
        //             scenario={scenario}
        //             isPulse={(scenario.info.control.settings as MediaDeviceSettings).media_control_type_id !== '1'}
        //         />
        //     ); // todo scenario media
        case CONTROL_TYPE_ID_THERMOSTAT:
            return (
                <div className="device-body">
                    <div className="device-digit">{(scenario.info.value / 10).toFixed(1)}</div>
                </div>
            )

        case CONTROL_TYPE_ADV_THERMOSTAT:
            return (
                <div className="device-body">
                    <div className="device-digit">{(scenario.info.value / 10).toFixed(1)}</div>
                </div>
            )

        case CONTROL_TYPE_ID_FANCOIL:
            return (
                <div className="device-body" style={{gap: "0 1.5rem"}}>
                    <div className="device-digit">{(scenario.info.value / 10).toFixed(1)}</div>
                    <div className="fancoil-button-status-container">
                        <div className="device-button-saved">
                            <img src={iconMode} alt="" />
                        </div>
                        <div className="device-button-saved">
                            <img src={iconFan} alt="" />
                        </div>
                        <div className="device-button-saved">
                            <img src={iconPower} alt="" />
                        </div>
                    </div>
                </div>
            )
        case CONTROL_TYPE_ID_VRF:
            return (
                <div className="device-body" style={{gap: "0 1.5rem"}}>
                    <div className="device-digit">{(scenario.info.value / 10).toFixed(0)}</div>
                    <div className="fancoil-button-status-container">
                        <div className="device-button-saved">
                            <img src={VRFFanIcon} alt="" />
                        </div>
                        <div className="device-button-saved">
                            <img src={VRFModeIcon} alt="" />
                        </div>
                        <div className="device-button-saved">
                            <img src={vrfPowerIcon} alt="" />
                        </div>
                    </div>
                </div>
            )
    }

    return (
        <div className="device-body">

        </div>
    )
})


type IconType = {
    icons: any
    onClick: (key?: any) => any
    close: () => any
}
export const ScenarioIconModal = memo(function ({icons, onClick, close}: IconType) {
    const {t} = useLocalization()
    const icon = icons?.map(r => (
        <div className="_icon-box" key={r.key} {...onClickHandler(()=>onClick(r.key))}>
            <img src={r.icon} alt="" />
        </div>
    ))
    return (
        <div className="icon-modal-container">
            <div className="icon-modal">
                <div className="icon-modal-box">{icon}</div>
                <div className="icon-modal-actions">
                    <button {...onClickHandler(close)}>{t('cancel')}</button>
                </div>
            </div>
        </div>
    )
})

export const ScenarioCreateScreen = memo(function ScenarioCreateScreen() {
    const [rpc] = useRPC()

    const {t} = useLocalization()
    const inputRef = useRef<HTMLInputElement>()
    const [setActiveInput, renderKeyboard] = useKeyboard()
    const [scenarioName, setScenarioName] = useState("")
    const [isNotification, setIsNotification] = useState(false)
    const [showOnFooter, setShowOnFooter] = useState(false)
    const [scenarioId, setScenarioId] = useState("")
    const {success, failure} = useMessage()
    const dispatch = useDispatch()

    const mediaList = useSelector(state => state.control.mediaList)
    const controlList = useSelector(state => state.control.controlList).filter(r => !(r?.parameters as HideControlParameters)?.hide_control)
    const controlTypeSet = useSetSelector(state => state.control.controlTypeList)
    const selectedScenario = useSelector(state => state.ui.scenarioScreen.selectedScenario)
    const [selectedOrderOption, setSelectedOrderOption] = useState(0)
    const [defaultColor, setDefaultColor] = useState(colorList[0]);
    const [powerStatus, setPowerStatus] = useState(0);
    const [vrfPowerStatus, setVrfPowerStatus] = useState(0)
    const [fanStatus, setFanStatus] = useState(0)
    const [vrfFanStatus, setVrfFanStatus] = useState(0)
    const [vrfModeStatus, setVrfModeStatus] = useState(0)
    const [modeStatus, setModeStatus] = useState(0)

    const previousSelectedOrderOption = usePrevious(selectedOrderOption)
    const [devices, setDevices] = useState<DeviceInfo[]>([{
        control: null,
        controlType: controlTypeSet[CONTROL_TYPE_ID_ALARM],
        media: null,
        value: null
    }])
    const [iconType, setIconType] = useState(iconScenario);
    const [modalClose, setModalClose] = useState(false);
    const iconPackage = useMemo(()=> [
        {
            key: '1',
            icon: icon1
        },
        {
            key: '2',
            icon: icon2
        },
        {
            key: '3',
            icon: icon3
        },
        {
            key: '4',
            icon: icon4
        },
        {
            key: '5',
            icon: icon5
        },
    ], []);

    const [operations, setOperations] = useState<OperationInfo[]>([])

    const forceUpdate = useForceUpdate()

    useEffect(() => {
        let newDevices = [...devices]
        let changed = false
        for (const control of controlList) {
            if (!(controlTypeSet[control.type_id] && controlTypeSet[control.type_id].show_on_scenario)) {
                continue
            }

            const hasDevice = newDevices.some(d => d.media == null && d.control != null && d.control.id === control.id)
            if (!hasDevice) {
                let value = null

                if (control.type_id === CONTROL_TYPE_ID_DIMMER) {
                    value = 50
                } else if (control.type_id === CONTROL_TYPE_ID_THERMOSTAT) {
                    value = 250;
                } else if (control.type_id === CONTROL_TYPE_ADV_THERMOSTAT) {
                    value = 250;
                } else if (control.type_id === CONTROL_TYPE_ID_FANCOIL) {
                    value = 250;
                } else if (control.type_id === CONTROL_TYPE_ID_VRF) {
                    value = 250;
                } else if (control.type_id === CONTROL_TYPE_ID_ANALOG) {
                    value = 50;
                }else if (control.type_id === "401") {
                    value = 50;
                }else if (control.type_id === "402") {
                    value = 50
                } else if (control.type_id === CONTROL_TYPE_ID_ELEVATOR) {
                    value = 1
                    // } else if (control.type_id === '6') {
                    //     if ((control.settings as MediaDeviceSettings).media_control_type_id !== '1') {
                    //         value = 0;
                    //     } // todo media scenario
                }

                newDevices.push({
                    control: control,
                    controlType: controlTypeSet[control.type_id],
                    media: null,
                    value
                })
                changed = true
            }
        }
        for (const media of mediaList) {
            const hasDevice = newDevices.some(d => d.media?.id === media.id)
            if (!hasDevice) {
                newDevices.push({
                    control: null,
                    controlType: null,
                    media,
                    value: media.type_id === MEDIA_TYPE_ID_AIR_CONDITIONER ? null : 0
                })
                changed = true
            }

        }
        if (changed || previousSelectedOrderOption !== selectedOrderOption) {
            newDevices = newDevices.sort((a, b) => {
                if (selectedOrderOption === 1) { // Alan
                    if (a.media != null && b.media != null) {
                        return 0
                    } else if (a.media != null) {
                        return 1
                    } else if (b.media != null) {
                        return -1
                    }

                    if (a.control == null) {
                        return -1
                    }

                    if (b.control == null) {
                        return 1
                    }

                    return a.control.area_id.localeCompare(b.control.area_id)
                }

                if (selectedOrderOption === 2) { // Tip
                    if (a.media != null && b.media != null) {
                        return 0
                    } else if (a.media != null) {
                        return 1
                    } else if (b.media != null) {
                        return -1
                    }

                    if (a.control == null) {
                        return -1
                    }

                    if (b.control == null) {
                        return 1
                    }

                    return a.control.type_id.localeCompare(b.control.type_id)
                }

                if (selectedOrderOption === 3) { // A-Z


                    if (a.media == null && a.control == null) {
                        return -1
                    }

                    if (b.media == null && b.control == null) {
                        return 1
                    }

                    const aName = a.control?.name || a.media?.name || ""
                    const bName = b.control?.name || b.media?.name || ""
                    return aName.localeCompare(bName)
                }

                if (a.media != null && b.media != null) {
                    return 0
                } else if (a.media != null) {
                    return 1
                } else if (b.media != null) {
                    return -1
                }

                if (a.media == null && a.control == null) {
                    return -1
                }

                if (b.media == null && b.control == null) {
                    return 1
                }

                return a.control.id.localeCompare(b.control.id) // todo temporary
            })
            changed = true
        }

        if (changed) {
            setDevices(newDevices)
        }
    }, [devices, controlList, selectedOrderOption, previousSelectedOrderOption, controlTypeSet, mediaList])

    useEffect(() => {
        if (selectedScenario == null) {
            return
        }

        if (operations.length === selectedScenario.operation_list.length) {
            // Scenario was already loaded, so return
            return
        }

        setScenarioName(selectedScenario.name)
        setIconType(selectedScenario.icon_type || iconScenario)
        setScenarioId(selectedScenario.id)
        setIsNotification(selectedScenario.is_notification)
        setShowOnFooter(selectedScenario.show_on_footer)
        if (devices && devices.length) {
            const operationList = []
            for (const operation of selectedScenario.operation_list) {
                const deviceInfo = devices.find(device => device.control?.id === operation.relational_id || device.media?.id === operation.relational_id || operation.relational_id === "alarm" || false)
                if (deviceInfo == null) {
                    // todo should show error?
                    continue
                }

                const operationInfo: OperationInfo = {
                    delay: operation.delay_seconds,
                    info: {
                        control: deviceInfo.control,
                        controlType: deviceInfo.controlType,
                        media: deviceInfo.media,
                        value: operation.value,
                        color: operation.rgb_color,
                        fan_coil: operation?.fan_coil,
                        vrf: operation?.vrf
                    }
                }

                operationList.push(operationInfo)
            }

            setOperations(operationList)
        }
        // eslint-disable-next-line
    }, [selectedScenario, devices])

    const setSelected = useCallback((info: DeviceInfo, value: number) => {
        info.value = value
        forceUpdate()
    }, [forceUpdate])

    const increase = useCallback((info: DeviceInfo, diff: number, limit: number) => {
        let value: number = info.value
        value += diff

        if (diff > 0) {
            if (value > limit) {
                value = limit
            }
        } else {
            if (value < limit) {
                value = limit
            }
        }

        info.value = value
        forceUpdate()
    }, [forceUpdate])

    const changeColor = useCallback((info: DeviceInfo, isUp: boolean) => {
        const oldColor = info.color || colorList[0]
        let newIndex = colorList.findIndex(el => el.r === oldColor.r && el.g === oldColor.g && el.b === oldColor.b) + (isUp ? 1 : -1)
        if (newIndex === -1) newIndex = colorList.length - 1
        if (newIndex === colorList.length) newIndex = 0
        info.color = colorList[newIndex]
        forceUpdate()
    }, [forceUpdate])


    const onPowerStatus = useCallback((info: DeviceInfo) => {
        let newPowerStatus = false
        if (powerStatus === 0) {
            setPowerStatus(1)
            newPowerStatus = true
        } else if (powerStatus === 1) {
            setPowerStatus(0)
            newPowerStatus = false
        }
        info.fan_coil = {
            ...info.fan_coil,
            power_status: newPowerStatus
        }
        forceUpdate()
    }, [powerStatus, forceUpdate])

    const onVRFPowerStatus = useCallback((info: DeviceInfo) => {
        let newPowerStatus = false
        if (vrfPowerStatus === 0) {
            setVrfPowerStatus(1)
            newPowerStatus = true
        } else if (vrfPowerStatus === 1) {
            setVrfPowerStatus(0)
            newPowerStatus = false
        }
        info.vrf = {
            ...info.vrf,
            power_status: newPowerStatus ? 'on' : 'off'
        }
        forceUpdate()
    }, [vrfPowerStatus, forceUpdate])

    const onVRFFanStatus = useCallback(
        (info: DeviceInfo) => {
            //'slow' | 'low' | 'med' | 'high' | 'auto' | 'pwr'
            let newFanStatus = vrfFanStatus
            if (newFanStatus < 5) {
                newFanStatus++
            } else {
                if (newFanStatus === 5) {
                    newFanStatus = 0
                } else {
                    newFanStatus--
                }
            }
            setVrfFanStatus(newFanStatus)
            if (newFanStatus === 0) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "slow"
                }
            } else if (newFanStatus === 1) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "low"
                }
            } else if (newFanStatus === 2) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "med"
                }
            } else if (newFanStatus === 3) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "high"
                }
            } else if (newFanStatus === 4) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "auto"
                }
            } else if (newFanStatus === 5) {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "pwr"
                }
            } else {
                info.vrf = {
                    ...info.vrf,
                    fan_speed: "auto"
                }
            }
            forceUpdate()
        },
        [vrfFanStatus, forceUpdate]
    )

    const onFanStatus = useCallback(
        (info: DeviceInfo) => {
            let newFanStatus = fanStatus
            if (newFanStatus < 3) {
                newFanStatus++
            } else {
                if (newFanStatus === 3) {
                    newFanStatus = 0
                } else {
                    newFanStatus--
                }
            }
            setFanStatus(newFanStatus)
            if (newFanStatus === 0) {
                info.fan_coil = {
                    ...info.fan_coil,
                    fan_speed: "low"
                }
            } else if (newFanStatus === 1) {
                info.fan_coil = {
                    ...info.fan_coil,
                    fan_speed: "medium"
                }
            } else if (newFanStatus === 2) {
                info.fan_coil = {
                    ...info.fan_coil,
                    fan_speed: "high"
                }
            } else if (newFanStatus === 3) {
                info.fan_coil = {
                    ...info.fan_coil,
                    fan_speed: "auto"
                }
            } else {
                info.fan_coil = {
                    ...info.fan_coil,
                    fan_speed: "auto"
                }
            }
            forceUpdate()
        },
        [fanStatus, forceUpdate]
    )


 const onVRFModeStatus = useCallback(
        (info: DeviceInfo) => {
            //"cool" | "fan"| "ai" | "nem" | "heat"
            let newFanStatus = vrfModeStatus
            if (newFanStatus < 4) {
                newFanStatus++
            } else {
                if (newFanStatus === 4) {
                    newFanStatus = 0
                } else {
                    newFanStatus--
                }
            }
            setVrfModeStatus(newFanStatus)
            if (newFanStatus === 0) {
                info.vrf = {
                    ...info.vrf,
                    mode: "cool"
                }
            } else if (newFanStatus === 1) {
                info.vrf = {
                    ...info.vrf,
                    mode: "fan"
                }
            } else if (newFanStatus === 2) {
                info.vrf = {
                    ...info.vrf,
                    mode: "ai"
                }
            } else if (newFanStatus === 3) {
                info.vrf = {
                    ...info.vrf,
                    mode: "nem"
                }
            } else if (newFanStatus === 4) {
                info.vrf = {
                    ...info.vrf,
                    mode: "heat"
                }
            } else {
                info.vrf = {
                    ...info.vrf,
                    mode: "cool"
                }
            }
            forceUpdate()
        },
        [vrfModeStatus, forceUpdate]
    )


    const onModeStatus = useCallback(
        (info: DeviceInfo) => {
            let newModeStatus = false
            if (modeStatus === 0) {
                setModeStatus(1)
                newModeStatus = true
            } else if (modeStatus === 1) {
                setModeStatus(0)
                newModeStatus = false
            }
            info.fan_coil = {
                ...info.fan_coil,
                mode: newModeStatus
            }
            forceUpdate()
        },
        [modeStatus, forceUpdate]
    )

    const add = useCallback((info: DeviceInfo) => {
        if (info.value == null) {
            return
        }
        if(info.color === undefined){
            info.color = defaultColor
        }
        setDefaultColor(info.color);
        setOperations(operations => ([...operations, {info: {...info}, delay: 0}]))
    }, [defaultColor])

    const move = useCallback((info: OperationInfo, diff: number) => {
        const index = operations.indexOf(info)
        if (index === 0 && diff < 0) {
            return
        } else if (index === (operations.length - 1) && diff > 0) {
            return
        }

        const newScenarios = [...operations]
        newScenarios.splice(index, 1)
        newScenarios.splice(index + diff, 0, info)

        setOperations(newScenarios)
    }, [operations])

    const remove = useCallback((info: OperationInfo) => {
        setOperations(operations.filter(i => i !== info))
    }, [operations])

    const onFocus = useCallback(() => {
        setActiveInput([inputRef, scenarioName, setScenarioName])
    }, [scenarioName, setActiveInput])

    const onBlur = useCallback(() => {
        setActiveInput(null)
    }, [setActiveInput])

    const close = useCallback(() => dispatch(toggleScenarioScreenAction(null)), [dispatch])

    const selectIcon = useCallback(() => setModalClose(true) ,[])

    const saveIcon = useCallback((key?: any)=> {
        const filtered = iconPackage.find(r => r.key === key ? r.icon : null)
        setIconType(filtered.icon)
        setModalClose(false)
    }, [iconPackage])

    const save = useCallback(() => {
        if (!scenarioName || !scenarioName.trim()) {
            failure(t("PLS_ENTER_SCENARIO_NAME"))

            return
        }

        if (!operations || !operations.length) {
            failure(t("ACTION_LIST_CANNOT_BE_EMPTY"))

            return
        }
        const scenario: ScenarioModel = {
            id: scenarioId,
            name: scenarioName,
            is_notification: isNotification,
            show_on_footer: showOnFooter,
            icon_type: iconType === iconScenario ? '' : iconType,
            operation_list: operations.map(s => ({
                type: s.info.media != null ? "media" : "control",
                relational_id: s.info.media != null ? s.info.media.id : (s.info.control != null ? s.info.control.id : "alarm"),
                value: s.info?.control?.type_id === CONTROL_TYPE_ID_GLASS_DEVICE_BUTTON ? s?.info?.value === 0 ? 0 : (s?.info?.value === 25 ? 10 : (s?.info?.value === 50 ? 20 : (s?.info?.value === 75 ? 30 : (s?.info?.value === 100 ? 40 : s?.info?.value)))) : s.info?.value,
                delay_seconds: s.delay,
                rgb_color: s.info.color,
                fan_coil: s.info.fan_coil,
                vrf: s.info.vrf
            }))
        }
        console.log(scenario)
        rpc.updateScenario(scenario)
            .then(isSucceeded => {
                if (isSucceeded) {
                    success(t(scenarioId.length === 0 ? "SCENARIO_SUCCESSFULLY_SAVED" : "SCENARIO_SUCCESSFULLY_EDITED"))
                    close()
                } else {
                    return Promise.reject()
                }
            })
            .catch(failure)
    }, [t, close, operations, rpc, scenarioId, isNotification, showOnFooter, scenarioName, success, failure, iconType])

    const addDelay = useCallback((operation: OperationInfo, delay: number) => {
        let newDelay = operation.delay + delay
        if (newDelay < 0) {
            newDelay = 0
        }

        if (newDelay > 300) {
            newDelay = 300
        }

        operation.delay = newDelay
        forceUpdate()
    }, [forceUpdate])

    return (
        <>
            <div className="scenario">
                {
                renderIf(modalClose)(()=> (
                    <ScenarioIconModal icons={iconPackage} onClick={saveIcon} close={()=>setModalClose(false)}/>
                ))
                }
                <div className="content-divider">
                    <div className="content-wrapper-parent content-wrapper-left">
                        <div className="content-wrapper-left top-part">
                            <div className="actions">
                                <input
                                    maxLength={20}
                                    placeholder={t("ENTER_SCENARIO_NAME")}
                                    ref={inputRef}
                                    onChange={e => setScenarioName(e.target.value)}
                                    onFocus={onFocus} onBlur={onBlur}
                                    value={scenarioName}/>
                                <div className="content-actions">
                                    <div className="action" {...onClickHandler(selectIcon)}>
                                        <img src={iconType} alt="" />
                                        <span>{t('select_icon')}</span>
                                    </div>
                                    <div className="action" {...onClickHandler(close)}>
                                        <img src={iconCancel} alt=""/>
                                        <span>{t("CANCEL")}</span>
                                    </div>
                                    <div className="action" {...onClickHandler(save)}>
                                        <img src={iconSave} alt=""/>
                                        <span>{t("SAVE")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="content-settings-bottom-part mb-10 justify-content-left">
                                {
                                    showTypes.map((option, index) => (
                                        <div key={`show_type_option_${index}`}>
                                            {
                                                option === "is_notification" && <div
                                                    className="option mr-30"
                                                    {...onClickHandler(() => setIsNotification(!isNotification))}>
                                                    <span>{t(option)}</span>
                                                    <div className="selection">
                                                        {
                                                            renderIf(isNotification)(() =>
                                                                <div className="selected"/>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                option === "show_on_footer" && <div key={`show_type_option_${index}`}
                                                                                    className="option"
                                                                                    {...onClickHandler(() => setShowOnFooter(!showOnFooter))}>
                                                    <span>{t(option)}</span>
                                                    <div className="selection">
                                                        {
                                                            renderIf(showOnFooter)(() =>
                                                                <div className="selected"/>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="content-settings-bottom-part rounded">
                                {
                                    options.map((option, index) => (
                                        <div key={`option_${index}`}
                                             className="option"
                                             {...onClickHandler(() => setSelectedOrderOption(index))}>
                                            <span>{t(option)}</span>
                                            <div className="selection">
                                                {
                                                    renderIf(selectedOrderOption === index)(() =>
                                                        <div className="selected"/>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="content-wrapper-left devices">
                            {
                                devices.map(info => (
                                    <div className="device" key={info.control?.id || info.media?.id || "alarm"}>
                                        <div className="device-name">
                                            {info.control?.name || info.media?.name || "Alarm"}
                                        </div>
                                        {
                                            info.controlType?.id !== CONTROL_TYPE_ID_DIMMER_COLOR && info.controlType?.id !== CONTROL_TYPE_ID_FANCOIL &&
                                            <img
                                                src={info.media != null ?
                                                    mediaIcons[info.media.icon] :
                                                    getImage(info)}
                                                alt=""/>
                                        }
                                        <Device
                                            info={info}
                                            increase={increase}
                                            changeColor={changeColor}
                                            setSelected={setSelected}
                                            setPowerStatus={onPowerStatus}
                                            setFanMode={onFanStatus}
                                            setMode={onModeStatus}
                                            setVRFFanMode={onVRFFanStatus}
                                            setVRFMode={onVRFModeStatus}
                                            setVRFPowerStatus={onVRFPowerStatus}
                                        />
                                        <div className="add-button" {...onClickHandler(() => add(info))}>
                                            <span>
                                                {t("ADD")}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="content-wrapper-parent content-wrapper-right devices scenarios">
                        {
                            operations.map((scenario, index) => (
                                <Fragment key={index}>
                                    <div className="device delay">
                                        <div className="device-name">
                                            {t("DELAY_DURATION")}
                                        </div>
                                        <div className="edit-button" {...onClickHandler(() => addDelay(scenario, -10))}>
                                            -10
                                        </div>
                                        <div className="edit-button" {...onClickHandler(() => addDelay(scenario, -1))}>
                                            -1
                                        </div>
                                        <div className="time">
                                            {getDelay(scenario.delay, t)}
                                        </div>
                                        <div className="edit-button" {...onClickHandler(() => addDelay(scenario, 1))}>
                                            +1
                                        </div>
                                        <div className="edit-button" {...onClickHandler(() => addDelay(scenario, 10))}>
                                            +10
                                        </div>
                                    </div>
                                    <div className="device">
                                        <div className="device-name">
                                            {(scenario.info.control == null && scenario.info.media == null) ? "Alarm" : (scenario.info.control?.name || scenario.info.media?.name || "")}
                                        </div>
                                        {
                                            scenario.info.controlType?.id !== CONTROL_TYPE_ID_FANCOIL && <img
                                            src={scenario.info.controlType?.image_set.default || mediaIcons[scenario.info.media?.icon]}
                                            alt=""/>
                                        }
                                        <Scenario scenario={scenario}/>
                                        <div className="scenario-buttons">
                                            <div className="add-button" {...onClickHandler(() => move(scenario, -1))}>
                                                <img src={iconUpArrow} alt=""/>
                                            </div>
                                            <div className="add-button" {...onClickHandler(() => move(scenario, 1))}>
                                                <img src={iconDownArrow} alt=""/>
                                            </div>
                                            <div className="add-button" {...onClickHandler(() => remove(scenario))}>
                                                <img src={iconClear} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            ))
                        }
                    </div>
                </div>
            </div>
            {
                renderKeyboard()
            }
        </>
    )
})
